// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_headerContainer__K-LFv {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* margin: 0 2rem; */
  background-color: rgba(255, 255, 255, 1);
  position: absolute;
  /* top: 2%; */
  width: 95%;
  z-index: 999999;
  width: 100%;
  height: 7vh;
}
.Header_buttonLink__v-l1o {
  align-items: center;
  /* color: #8d8d8d; */
  display: flex;
  font-family: Roboto;
  font-size: .875rem;
  font-weight: 400;
  margin: 0 2rem;
  position: relative;
  text-decoration: none;
}
.Header_headerSignup__9fIRJ {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 4rem;
  cursor: pointer;
}
.Header_headerSignup__9fIRJ p {
  color: #115a8e;
  font-family: Roboto;
  font-size: 0.875rem;
  font-weight: 500;
}

.Header_navBarItems__uFPT- {
  display: flex;
  justify-content: center;
}
.Header_navBarItems__uFPT- a {
  color: #8d8d8d;
  font-family: Roboto;
  font-size: 0.875rem;
  font-weight: 400;
  text-decoration: none;
  margin: 0 2rem;
  display: flex;
  align-items: center;
  position: relative;
}

/* a::after {
  content: "";
  display: block;
  margin: auto;
  height: 3px;
  width: 0;
  top: 5px;
  background: transparent;
  transition: all 0.3s;
} */

a::after {
  position: absolute;
  content: "";
  width: 0.8rem;
  height: 3px;
  top: 90%;
  left: 30%;
  background: #548dff;
  transition: transform 0.5s;
  transform: scaleX(0);
  transform-origin: left;
}

.Header_active__OmSSX::after {
  transform: scaleX(1);
}

.Header_active__OmSSX {
  color: #115A8E !important;
  font-weight: 500 !important;
}
.Header_item__Ky4D0{
  color:#115A8E !important;
}
.Header_navBarItems__uFPT- {
  margin-right: 2rem;
}
.Header_navBarItems__uFPT- p {
  margin: 0;
  padding: 0;
}
.Header_logoContainer__yZ7z3 {
  width: 9rem;
  margin-left: 4rem;
}

.Header_logoContainer__yZ7z3 img {
  width: 70%;
}
.Header_headerSignup__9fIRJ img {
  width: 1.5rem;
  margin-top: -1rem;
  margin-left: 0.6rem;
}
.Header_mobileMenuContainer__40SBe {
  display: none;
}

.Header_productsMenu__eQkgn {
  position: relative;
}
.Header_productsList__gON0C {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  position: absolute;
  top: 100%;
  right: -10%;
  width: 11.875rem;
  height: 16rem;
  border-radius: 0.5rem;
  background: #fff;
  box-shadow: 0px 0px 6px 0px rgba(23, 23, 23, 0.25);
}
.Header_logoutList__adOQm {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  position: absolute;
  top: 100%;
  right: 1%;
  width: 8%;
  /* height: 16rem; */
  border-radius: 0.5rem;
  background: #fff;
  box-shadow: 0px 0px 6px 0px rgba(23, 23, 23, 0.25);
}
.Header_verticalLine__8PCSy {
  width: 0.1rem;
  height: 1.5rem;
  stroke-width: 1px;
  background: #cecece;
}
.Header_signupimg__YPlXQ{
  height: 25px;
  width: 25px;
}
.Header_loginBtn__aYzBk {
  color: #548dff !important;
  font-weight: 500 !important;
}

.Header_registerBtn__Gpl\\+S {
  width: 6.8rem;
  height: 2rem;
  font-size:12px;
  border-radius: 0.3125rem;
  background: #548dff;
  display: flex;
  justify-content: center;
  align-items: center;
  border:0;
  color: white !important;
}
.Header_signupbtn__ex2Qf{
  background-color: transparent;
  color: #115A8E;
  border: none;
  font-weight: 500;
  font-size: 14px;
}
.Header_subMenuItem__5Lkfb {
  display: flex;
  align-items: center;
  margin: 0.6rem 0.8rem;
}

.Header_subMenuItem__5Lkfb img {
  width: 1rem;
}
.Header_subMenuItem__5Lkfb a {
  color: #6b6b6b;
  font-family: Roboto;
  font-size: 0.85rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
  padding: 0;
  margin-left: 0.4rem;
}
.Header_hrLine__2ivZS {
  width: 80%;
  border: 0.5 solid black;
  margin: 0.1rem auto;
}
.Header_mobileMenu__j0b-I {
  display: none;
}

@media only screen and (max-width: 767px) {
  .Header_headerContainer__K-LFv {
    display: none;
  }
  .Header_mobileMenu__j0b-I {
    width: 100%;
    height: 3.125rem;
    background: #fff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.6rem;
  }
  .Header_mobileMenu__j0b-I img {
    width: 55%;
  }

  .Header_mobileMenuExpand__MgW5W {
    width: 100%;
    height: 100vh;
    background: #fff;
    position: fixed;
    z-index: 99999999999 !important;
  }
  .Header_mobileIcon__\\+6l5N {
    display: flex;
    /* align-items: center; */
    justify-content: flex-end;
  }
  .Header_mobileMenuExpand__MgW5W img {
    width: 55%;
  }
  .Header_userDetail__5-0DU {
    width: 100%;
    height: 7.5625rem;
    background: #f6f6f6;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .Header_closeIcon__dYwhl {
    position: absolute;
    right: 2%;
    top: 4%;
  }
  .Header_userDetail__5-0DU img {
    width: 3.4rem;
  }
  .Header_menuItemsList__fRIjq a {
    text-decoration: none;
    display: flex;
    align-items: center;
    margin: 2.2em 2rem;
  }
  .Header_menuItemsList__fRIjq p {
    color: #000;
    font-family: Roboto;
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.8rem;
    margin: 0;
    padding: 0;
    margin-left: 0.5rem;
  }
  .Header_accordionSpacing__bGqg6 {
    margin: -1.5rem 0rem;
  }
  .Header_loginBtn__aYzBk {
    width: 12.5rem;
    height: 2.5rem;
  /* font-size:1.17vw; */
    border:0;
    border-radius: 0.25rem;
    background: #4294ff;
    color: white !important;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    margin-top: 40vh;
  }
  .Header_loginBtn__aYzBk p {
    margin: 0;
    padding: 0;
    color: #fff;
    font-family: Roboto;
    font-size: 0.9375rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.75rem; /* 186.667% */
  }
  .Header_imgIcons__i3oYQ {
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/components/HomePage/Header.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,eAAe;EACf,WAAW;EACX,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;;;;;GASG;;AAEH;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,kDAAkD;AACpD;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,kDAAkD;AACpD;AACA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,+CAA+C;IAC/C,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,+BAA+B;EACjC;EACA;IACE,aAAa;IACb,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;EACT;EACA;IACE,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,cAAc;EAChB,sBAAsB;IACpB,QAAQ;IACR,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB,EAAE,aAAa;EACrC;EACA;EACA;AACF","sourcesContent":[".headerContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  /* margin: 0 2rem; */\n  background-color: rgba(255, 255, 255, 1);\n  position: absolute;\n  /* top: 2%; */\n  width: 95%;\n  z-index: 999999;\n  width: 100%;\n  height: 7vh;\n}\n.buttonLink {\n  align-items: center;\n  /* color: #8d8d8d; */\n  display: flex;\n  font-family: Roboto;\n  font-size: .875rem;\n  font-weight: 400;\n  margin: 0 2rem;\n  position: relative;\n  text-decoration: none;\n}\n.headerSignup {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 4rem;\n  cursor: pointer;\n}\n.headerSignup p {\n  color: #115a8e;\n  font-family: Roboto;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.navBarItems {\n  display: flex;\n  justify-content: center;\n}\n.navBarItems a {\n  color: #8d8d8d;\n  font-family: Roboto;\n  font-size: 0.875rem;\n  font-weight: 400;\n  text-decoration: none;\n  margin: 0 2rem;\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n/* a::after {\n  content: \"\";\n  display: block;\n  margin: auto;\n  height: 3px;\n  width: 0;\n  top: 5px;\n  background: transparent;\n  transition: all 0.3s;\n} */\n\na::after {\n  position: absolute;\n  content: \"\";\n  width: 0.8rem;\n  height: 3px;\n  top: 90%;\n  left: 30%;\n  background: #548dff;\n  transition: transform 0.5s;\n  transform: scaleX(0);\n  transform-origin: left;\n}\n\n.active::after {\n  transform: scaleX(1);\n}\n\n.active {\n  color: #115A8E !important;\n  font-weight: 500 !important;\n}\n.item{\n  color:#115A8E !important;\n}\n.navBarItems {\n  margin-right: 2rem;\n}\n.navBarItems p {\n  margin: 0;\n  padding: 0;\n}\n.logoContainer {\n  width: 9rem;\n  margin-left: 4rem;\n}\n\n.logoContainer img {\n  width: 70%;\n}\n.headerSignup img {\n  width: 1.5rem;\n  margin-top: -1rem;\n  margin-left: 0.6rem;\n}\n.mobileMenuContainer {\n  display: none;\n}\n\n.productsMenu {\n  position: relative;\n}\n.productsList {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  flex-direction: column;\n  position: absolute;\n  top: 100%;\n  right: -10%;\n  width: 11.875rem;\n  height: 16rem;\n  border-radius: 0.5rem;\n  background: #fff;\n  box-shadow: 0px 0px 6px 0px rgba(23, 23, 23, 0.25);\n}\n.logoutList {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  flex-direction: column;\n  position: absolute;\n  top: 100%;\n  right: 1%;\n  width: 8%;\n  /* height: 16rem; */\n  border-radius: 0.5rem;\n  background: #fff;\n  box-shadow: 0px 0px 6px 0px rgba(23, 23, 23, 0.25);\n}\n.verticalLine {\n  width: 0.1rem;\n  height: 1.5rem;\n  stroke-width: 1px;\n  background: #cecece;\n}\n.signupimg{\n  height: 25px;\n  width: 25px;\n}\n.loginBtn {\n  color: #548dff !important;\n  font-weight: 500 !important;\n}\n\n.registerBtn {\n  width: 6.8rem;\n  height: 2rem;\n  font-size:12px;\n  border-radius: 0.3125rem;\n  background: #548dff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border:0;\n  color: white !important;\n}\n.signupbtn{\n  background-color: transparent;\n  color: #115A8E;\n  border: none;\n  font-weight: 500;\n  font-size: 14px;\n}\n.subMenuItem {\n  display: flex;\n  align-items: center;\n  margin: 0.6rem 0.8rem;\n}\n\n.subMenuItem img {\n  width: 1rem;\n}\n.subMenuItem a {\n  color: #6b6b6b;\n  font-family: Roboto;\n  font-size: 0.85rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin: 0;\n  padding: 0;\n  margin-left: 0.4rem;\n}\n.hrLine {\n  width: 80%;\n  border: 0.5 solid black;\n  margin: 0.1rem auto;\n}\n.mobileMenu {\n  display: none;\n}\n\n@media only screen and (max-width: 767px) {\n  .headerContainer {\n    display: none;\n  }\n  .mobileMenu {\n    width: 100%;\n    height: 3.125rem;\n    background: #fff;\n    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 0.6rem;\n  }\n  .mobileMenu img {\n    width: 55%;\n  }\n\n  .mobileMenuExpand {\n    width: 100%;\n    height: 100vh;\n    background: #fff;\n    position: fixed;\n    z-index: 99999999999 !important;\n  }\n  .mobileIcon {\n    display: flex;\n    /* align-items: center; */\n    justify-content: flex-end;\n  }\n  .mobileMenuExpand img {\n    width: 55%;\n  }\n  .userDetail {\n    width: 100%;\n    height: 7.5625rem;\n    background: #f6f6f6;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n  }\n  .closeIcon {\n    position: absolute;\n    right: 2%;\n    top: 4%;\n  }\n  .userDetail img {\n    width: 3.4rem;\n  }\n  .menuItemsList a {\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n    margin: 2.2em 2rem;\n  }\n  .menuItemsList p {\n    color: #000;\n    font-family: Roboto;\n    font-size: 1.125rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1.8rem;\n    margin: 0;\n    padding: 0;\n    margin-left: 0.5rem;\n  }\n  .accordionSpacing {\n    margin: -1.5rem 0rem;\n  }\n  .loginBtn {\n    width: 12.5rem;\n    height: 2.5rem;\n  /* font-size:1.17vw; */\n    border:0;\n    border-radius: 0.25rem;\n    background: #4294ff;\n    color: white !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 0 auto;\n    margin-top: 40vh;\n  }\n  .loginBtn p {\n    margin: 0;\n    padding: 0;\n    color: #fff;\n    font-family: Roboto;\n    font-size: 0.9375rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1.75rem; /* 186.667% */\n  }\n  .imgIcons {\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerContainer": `Header_headerContainer__K-LFv`,
	"buttonLink": `Header_buttonLink__v-l1o`,
	"headerSignup": `Header_headerSignup__9fIRJ`,
	"navBarItems": `Header_navBarItems__uFPT-`,
	"active": `Header_active__OmSSX`,
	"item": `Header_item__Ky4D0`,
	"logoContainer": `Header_logoContainer__yZ7z3`,
	"mobileMenuContainer": `Header_mobileMenuContainer__40SBe`,
	"productsMenu": `Header_productsMenu__eQkgn`,
	"productsList": `Header_productsList__gON0C`,
	"logoutList": `Header_logoutList__adOQm`,
	"verticalLine": `Header_verticalLine__8PCSy`,
	"signupimg": `Header_signupimg__YPlXQ`,
	"loginBtn": `Header_loginBtn__aYzBk`,
	"registerBtn": `Header_registerBtn__Gpl+S`,
	"signupbtn": `Header_signupbtn__ex2Qf`,
	"subMenuItem": `Header_subMenuItem__5Lkfb`,
	"hrLine": `Header_hrLine__2ivZS`,
	"mobileMenu": `Header_mobileMenu__j0b-I`,
	"mobileMenuExpand": `Header_mobileMenuExpand__MgW5W`,
	"mobileIcon": `Header_mobileIcon__+6l5N`,
	"userDetail": `Header_userDetail__5-0DU`,
	"closeIcon": `Header_closeIcon__dYwhl`,
	"menuItemsList": `Header_menuItemsList__fRIjq`,
	"accordionSpacing": `Header_accordionSpacing__bGqg6`,
	"imgIcons": `Header_imgIcons__i3oYQ`
};
export default ___CSS_LOADER_EXPORT___;
